import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Westminster, CO?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Westminster can take 2–6 months, especially during busy travel seasons. For families with spring break trips, business travelers, and students, that timeline is simply not viable.",
  },
  {
    q: "Can Westminster residents use the Denver Passport Agency?",
    a: "The Denver Passport Agency (3151 S Vaughn Way, Aurora, CO 80014) is about 20 miles from Westminster and is open to the public for urgent travel — but only by appointment, and only for documented emergencies with travel within 14 days. Fast Passport Center provides a predictable alternative without the uncertainty of waiting for a public appointment to open.",
  },
  {
    q: "What if my passport expires before a ski trip to Canada?",
    a: "This is one of the most common scenarios we see from Colorado families. Canada requires a valid passport for all air travel, and the Whistler and Banff crowds are full of Westminster, Broomfield, and Arvada families who discovered their passport expired mid-season. Standard mail-in renewal typically takes 2–6 months — far too long for a booked ski trip.",
  },
  {
    q: "Can Front Range Community College or Regis University students get a passport fast for study abroad?",
    a: "Yes. Study-abroad program deadlines often fall in October and February, but many students do not think about their passport until after acceptance. First-time applicants require an in-person acceptance clerk visit. We guide Westminster-area students through the exact location, forms, and timeline so they do not miss their program orientation.",
  },
  {
    q: "How quickly can travelers in Broomfield or Arvada receive an expedited passport?",
    a: "Broomfield and Arvada travelers have the same access to our expedited services as Westminster residents. Since we operate remotely, your physical location in the north Denver metro does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients in the area receive their passports within 2–9 business days.",
  },
  {
    q: "Can retirees in the Westminster area expedite a passport renewal?",
    a: "Yes — retired and senior travelers from Westminster, Broomfield, and surrounding communities are well within our Colorado service area. Whether you are planning a European river cruise, a Mediterranean tour, or a trip to Japan, we make the renewal process straightforward. You do not need to drive to the Denver Passport Agency. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Westminster travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Westminster, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Westminster metro area.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Westminster and north Denver metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}